<section class="page-title-area">
    <div class="container">
        <div class="page-title-content wow animate__animated animate__fadeInLeft" data-wow-delay="00ms" data-wow-duration="1000ms">
            <h1>RegisterPlay</h1>
			<p class="sub-title" style="color: #fff">The Engine Behind Amateur Sports<br>We power the logistics, payments, and growth behind amateur sport tournaments and leagues across the country.</p>
        </div>
    </div>
    <div class="shape2"><img src="assets/img/shape/shape2.png" alt="image"></div>
    <div class="shape3"><img src="assets/img/shape/shape3.png" alt="image"></div>
    <div class="shape5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape6"><img src="assets/img/shape/shape6.png" alt="image"></div>
    <div class="shape7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</section>

<!-- Stats Section -->
<section class="mt-4">
    <div class="container">
        <div class="section-heading">
            <h2><i class="fas fa-chart-line"></i> Trusted at Scale</h2>
        </div>

        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-value">25,000</div>
                <div class="stat-label">Teams registered for the 2025 season (so far)</div>
                <div class="stat-note">(24,000 in 2024)</div>
            </div>

            <div class="stat-card">
                <div class="stat-value">500,000+</div>
                <div class="stat-label">Users across 73 white-labeled websites</div>
                <div class="stat-note">Representing 10 major organizations</div>
            </div>

            <div class="stat-card">
                <div class="stat-value">335,000+</div>
                <div class="stat-label">Games scheduled, managed, and scored</div>
                <div class="stat-note">Through our comprehensive platform</div>
            </div>
        </div>

        <div class="section-heading">
            <h2><i class="fas fa-money-bill-wave"></i> Built with Stripe. At Scale.</h2>
        </div>

        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-value">$17.4M+</div>
                <div class="stat-label">Processed for our clients</div>
            </div>

            <div class="stat-card">
                <div class="stat-value">600+ Connected Accounts</div>
                <div class="stat-label">Direct access to your funds</div>
            </div>
        </div>
    </div>
</section>

<!-- Team Section -->
<section class="team-section">
    <div class="container">
        <h2 class="text-center">Built by People Who’ve Been on the Dojo, the Field…<br>...and Everything In Between</h2>
        <div style="margin: 14px 0">Our team brings over <span class="highlight">70+ years of combined experience</span>. Every member of our team has played sports, and many have coached youth teams or run tournaments. We’re not just building software — we’re solving the problems we’ve lived.</div>
        <div class="team-block">
            <img class="mat-elevation-z10" src="/assets/img/md.jpg" alt="Team member on dojo">
            <div>
                <h3>From the Dojo</h3>
                <div>We’ve competed. We’ve trained. We know what it means to show up, stay disciplined, and lead with precision. That’s the mindset behind our product.</div>
            </div>
        </div>
        <div class="team-block">
            <img class="mat-elevation-z10" src="/assets/img/kb.jpg" alt="Coach on field">
            <div>
                <h3>To the Field</h3>
                <div>We’ve coached on dirt fields, managed last-minute changes, and made sure every kid got their chance to play. We know what matters on game day.</div>
            </div>
        </div>
    </div>
</section>

<!-- Contact Section -->
<section class="mt-4 contact-section">
    <div class="container">
        <div class="section-heading">
            <h2><i class="fas fa-comments"></i> Let's Talk</h2>
            <p>We've built something solid — and we're just getting started.<br>Would you like to learn more about how RegisterPlay can help your organization?</p>
        </div>

        <div class="contact-info">
            <p><a href="mailto:info@registerplay.com">info&#64;registerplay.com</a> &nbsp; or &nbsp; <a href="tel:7755777529">(775) 577-7529</a></p>
        </div>
    </div>
</section>